import React, { Component } from 'react';

class OpbFloorsItem extends Component {
    handleChange = (e) => {
    // 층 표시,층 정보 수정
        this.props.handleValueChange(this.props.index, e.target.name, e.target.value);
    };
    
    handleServiceInfo = (value) => {
    // 편의 시설 선택
        let serviceInfo = this.props.floor.serviceInfo ? this.props.floor.serviceInfo : "";
        let arrService = serviceInfo.split("|");
        if (arrService.includes(value)) {
            arrService = arrService.filter(service => service !== value);
            if (arrService.length === 0) serviceInfo = "";
            arrService.map((service, i) => {
                if (i === 0) serviceInfo = service;
                else serviceInfo += "|" + service;
                return service;
            });
        }
        else {
            serviceInfo = (serviceInfo ? serviceInfo+"|" + value : value);
        }
        
        this.props.handleValueChange(this.props.index, "serviceInfo", serviceInfo);
    };

    render() {
        const arrService = (this.props.floor.serviceInfo ? this.props.floor.serviceInfo.split("|") : [""]);
        
        return (
            <tr>
                <td data-label="번호" className="text-align-center">
                    {this.props.index + 1}
                </td>
                <td data-label="층">
                    <input type="text" className="input-box w100per text-align-center" title="층수" name="floorName" value={this.props.floor.floorName} onChange={this.handleChange} />
                </td>
                <td data-label="층 정보">
                    <input type="text" className="input-box w100per text-align-center" title="층정보" name="floorInfo" value={this.props.floor.floorInfo} onChange={this.handleChange} />
                </td>
                <td data-label="편의 시설 선택">
                    <div className="s-icon-wrap">
                        <div className={`floorInfo-floorname-serviceInfo ${arrService.includes('FL001') ? "active" : ""}`} onClick={() => {this.handleServiceInfo("FL001")}}>
                            <img className="" src={"/assets/images/ic-FL001.png"} alt="화장실" />
                        </div>
                        <div className={`floorInfo-floorname-serviceInfo ${arrService.includes('FL006') ? "active" : ""}`} onClick={() => {this.handleServiceInfo("FL006")}}>
                            <img className="" src={"/assets/images/ic-FL006.png"} alt="카페" />
                        </div>
                        <div className={`floorInfo-floorname-serviceInfo ${arrService.includes('FL007') ? "active" : ""}`} onClick={() => {this.handleServiceInfo("FL007")}}>
                            <img className="" src={"/assets/images/ic-FL007.png"} alt="사은품" />
                        </div>
                    </div>
                </td>
            </tr>
        )
    }
}

export default OpbFloorsItem;